import React, { useEffect, useState } from 'react'
import { Image } from 'antd-mobile-v5'
import Tag from '../BuyCards/components/ChanghuanTag'
import styles from './ClubVipChangeEcards.module.css'
import { useHistory } from 'react-router-dom'
import { useGetVipAllEcardsOptions } from '../../services/hooks'
import { getCardFaceImageUrl } from '../../services/utilities'
import LoadingStatus from '../../components/FormTools/Loading'
import { getPadiWxId } from '../../utils/user'
import { getParameterByName } from '../../components/common/utils'

const VipChangeEcardsRotator = () => {
  const { push } = useHistory()
  const { loading } = useGetVipAllEcardsOptions({
    onSuccess: (data) => {
      if (data) setOptions(data)
    },
  })

  const [selectedImage, setSelectedImage] = useState(0)
  const [options, setOptions] = useState([])
  const padiWxId = getPadiWxId()
  const pageVipId = getParameterByName('pageVipId')

  const callbackUrl = pageVipId ? `/vip_change_ecards?pageVipId=${pageVipId}` : '/vip_change_ecards'

  useEffect(() => {
    const isLogin = getParameterByName('isLogin')
    if (padiWxId && !isLogin) push(callbackUrl)
  }, [])

  const changeImage = (index) => {
    setSelectedImage(index)
  }

  const getImgSrc = () => {
    const currentItem = options[selectedImage]
    // 统一入口：绝对 URL 原样、普通版走随包 certs/、相对逻辑名按语言取 CDN 上的变体（CHNA-2776）
    return getCardFaceImageUrl(currentItem.imgFile, currentItem.desc)
  }

  if (loading) return <LoadingStatus />

  return (
    <div className={styles.wrapper}>
      {options && options.length > 0 && <Image className={styles.card} src={getImgSrc()} />}
      <h4 className={styles['options-title']}>选择卡面</h4>
      {options && options.length > 0 ? (
        <div className={styles.tags}>
          {options.map((option, index) => (
            <Tag key={option.ecardImageId} selected={index === selectedImage} onClick={() => changeImage(index)}>
              {option.desc}
            </Tag>
          ))}
        </div>
      ) : (
        <div>暂无可更换的卡面</div>
      )}
      <div className={styles.bottom}>
        <div className={styles.button} onClick={() => push(`/emailLogin?referer=${encodeURIComponent(callbackUrl)}`)}>
          登录识别可使用证书
        </div>
      </div>
    </div>
  )
}

export default VipChangeEcardsRotator
